import React, { useState, useEffect } from 'react';
import { Breadcrumb, DatePicker } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';
import {
  getSpecificPAgroLiderRequest,
  saveAgroLiderRequest,
} from 'modules/agroLiderModule/requests/agroLiderRequests';
import dayjs from "dayjs";

const AgroLiderEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);
  const [file1, setFile1] = useState<string | null>(null);
  const [file1Changed, changedFile1] = useState<boolean>(false);

  useEffect(() => {
    toggleLoading(true);

    getSpecificPAgroLiderRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;

          setFields([
            {
              name: ['id'],
              value: data.rows.id,
            },
            {
              name: ['name'],
              value: data.rows.name,
            },
            {
              name: ['fileImage1'],
              value: data.rows.fileImage,
            },
            {
              name: ['fileURL'],
              value: data.rows.uploadedFile1,
            },
            {
              name: ['dateAdd'],
              value: dayjs(data.rows.dateAdd, 'YYYY/MM/DD HH:mm:ss'),
            },
            {
              name: ['sortOrder'],
              value: data.rows.sortOrder,
            },
            {
              name: ['isActive'],
              value: data.rows.isActive || false,
            },
          ]);
          form.setFieldsValue({
            fileImage1: data.rows?.fileImage,
            fileURL: data.rows?.uploadedFile1,
          });

          setFileImage1(data.rows?.fileImage);

          setFile1(data.rows.uploadedFile1);

          if (data.rows.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/agro-lider');
        }
      })
      .catch(() => {
        history.push('/agro-lider');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveAgroLiderRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/agro-lider">AGROlider</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/agro-lider/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Okładka"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  hideTags
                />
              </Form.Item>

              <Form.Item
                name="dateAdd"
                label="Data dodania"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {/*// @ts-ignore*/}
                <DatePicker showTime />
              </Form.Item>

              <Form.Item
                name="name"
                label="Nazwa"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="fileURL"
                label="Plik do pobrania PDF"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormFileUpload
                  file={file1}
                  setFile={(e) =>
                    updateFile(e, 'fileURL', setFile1, changedFile1)
                  }
                  id={form.getFieldsValue()?.id}
                  isNew={file1Changed}
                  field="fileURL"
                  number={1}
                />
              </Form.Item>

              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/agro-lider">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/agro-lider">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default AgroLiderEdit;
